<template>
  <div class="container-fluid" :class="`container-fluid--${mode}`" :style="fluidStyle">
    <div v-if="!isPurchasable" class="warning">
      <div class="warning-inner">판매 기간이 종료된 상품입니다.</div>
    </div>
    <div v-else class="container">
      <!-- section left -->
      <section>
        <!-- cover -->
        <div class="bundle-cover">
          <div class="bundle-cover__img">
            <img :src="coverImgUrl" alt="" />
          </div>
          <div class="bundle-wrap bundle-cover__titles">
            <h4 v-if="subTitle" :style="{ color: subTitleColor }">
              {{ subTitle }}
            </h4>
            <h3 class="" :style="[{ color: titleColor }, titleStyle]" v-html="title"></h3>
          </div>
        </div>
        <!-- 구성 -->
        <bundle-composition
          :productTotal="productTotal"
          :products="products"
          :goods="goods"
          :coverImgUrl="coverImgUrl"
          :pointColor="pointColor"
        />
      </section>
      <!-- section right -->
      <section class="bundle-wrap bundle-wrap-right">
        <div v-if="content" class="bundle-content" :style="contentStyle" v-html="content"></div>
        <div class="bundle-subimg">
          <img v-if="subImgUrl" :src="subImgUrl" alt="" style="width: 100%" />
        </div>
        <bundle-prices v-bind="prices" />
        <div class="bundle-btns">
          <button class="bundle-btn bundle-btn--full" :style="btnStyle" @click="goPurchase">
            <span class="btn-label">{{ buttonLabel }}</span>
          </button>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import VueSlickCarousel from 'vue-slick-carousel';
import 'vue-slick-carousel/dist/vue-slick-carousel.css';

import BundlePrices from './components/bundle/bundle-prices';
import BundleComposition from './components/bundle/bundle-composition';

export default {
  name: 'bundle-app',
  props: [
    'isPurchasable',
    'paddingTop',
    'paddingBottom',
    'backgroundColor',
    'mode',
    'productId',
    'coverImgUrl',
    'title',
    'titleColor',
    'subTitle',
    'subTitleColor',
    'pointColor',
    'content',
    'subImgUrl',
    'buttonLabel',
    'buttonLabelColor',
    'buttonColor',
    'bundleData',
    'prices',
    'productList',
  ],
  components: {
    BundlePrices,
    BundleComposition,
    VueSlickCarousel,
  },
  computed: {
    productTotal() {
      return this.goods ? this.productList.length - 1 : this.productList.length;
    },
    products() {
      const list = this.productList.filter((ele) => ele.type != 'GOODS');
      const chunkSize = this.goods ? 3 : 5;
      return _.chunk(list, chunkSize);
    },
    goods() {
      return this.productList.filter((ele) => ele.type === 'GOODS')[0];
    },
    btnStyle() {
      return {
        color: this.buttonLabelColor,
        backgroundColor: this.buttonColor,
      };
    },
  },
  data() {
    return {
      isMobile: true,
      hasSubTitle: false,
      fluidStyle: {},
      titleStyle: {},
      contentStyle: {},
      infoTitle: {},
      infoPrices: {},
    };
  },
  watch: {
    isMobile() {
      this.settingStyles();
    },
  },
  mounted() {
    this.hasSubTitle = Boolean(this.subTitle.trim());
    this.checkMobile();
    this.settingStyles();

    window.addEventListener('resize', () => {
      this.checkMobile();
    });
  },
  methods: {
    checkMobile() {
      this.isMobile = window.innerWidth < 960 ? true : false;
    },
    settingStyles() {
      this.settingFluidStyle();
      this.settingTitleStyle();
      this.settingContentStyle();
    },
    settingFluidStyle() {
      //-- 구매불가일때 패딩은 mobile, pc 항상 유지
      if (!this.isPurchasable) {
        this.fluidStyle = {
          paddingTop: this.paddingTop / 10 + 'rem',
          paddingBottom: this.paddingBottom / 10 + 'rem',
        };
        //-- 구매 가능 일때 패딩은 mobile 은 0, pc 는 유지
      } else {
        this.fluidStyle = {
          paddingTop: this.isMobile ? 0 : this.paddingTop / 10 + 'rem',
          paddingBottom: this.isMobile ? 0 : this.paddingBottom / 10 + 'rem',
        };
      }
      this.fluidStyle = {
        ...this.fluidStyle,
        backgroundColor: this.backgroundColor,
      };
    },
    settingTitleStyle() {
      if (this.isMobile) {
        this.titleStyle = {
          fontSize: '2.4rem',
        };
      } else {
        this.titleStyle = {
          fontSize: this.hasSubTitle ? '2.8rem' : '3.2rem',
          lineHeight: this.hasSubTitle ? '4.2rem' : '4.8rem',
        };
      }
      this.titleStyle = { ...this.titleStyle, '-webkit-line-clamp': this.hasSubTitle ? 1 : 2 };
    },
    settingContentStyle() {
      if (this.goods) {
        this.contentStyle = {
          '-webkit-line-clamp': this.isMobile ? 6 : 7,
          'max-height': '15.4rem',
        };
      } else {
        this.contentStyle = {
          '-webkit-line-clamp': this.isMobile ? 8 : 9,
          'max-height': '20.2rem',
        };
      }
    },

    goPurchase() {
      window.location.href = `/products/${this.bundleData.id}`;
    },
  },
};
</script>
